<script setup lang="ts">
import { computed } from 'vue'
import { useMapCoordinateStore } from '@/stores/mapCoordinateStore'
import { useGameStore } from '@/stores/gameStore'
import { usePlayerRelationStore } from '@/stores/playerRelations'
import { useMapStore } from '@/stores/mapStore'
import PlayerName from '@/components/Objects/PlayerName.vue'
import type Fleet from '@/types/Fleet'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const mapCoordinateStore = useMapCoordinateStore()
const gameStore = useGameStore()
const playerRelationsStore = usePlayerRelationStore()
const mapStore = useMapStore()

const onClick = (fleet: Fleet) => {
  mapStore.focusMap(fleet.xPos, fleet.yPos)
}

const largeFleets = computed(() => {
  // Reference fleetsVersion to trigger reactivity when raw Map changes
  void mapCoordinateStore.fleetsVersion
  return Array.from(mapCoordinateStore.fleets.values())
    .filter(fleet => fleet.playerId !== gameStore.player?.id)
    .filter(fleet => fleet.ships >= 50)
    .sort((a, b) => {
      const aIsEnemy = playerRelationsStore.isEnemy(a.playerId)
      const bIsEnemy = playerRelationsStore.isEnemy(b.playerId)

      // Enemies first
      if (aIsEnemy && !bIsEnemy) return -1
      if (!aIsEnemy && bIsEnemy) return 1

      // Then sort by name
      const aName = playerRelationsStore.relations.get(a.playerId)?.name || ''
      const bName = playerRelationsStore.relations.get(b.playerId)?.name || ''
      return aName.localeCompare(bName)
    })
})
</script>

<template>
  <div class="pt-2 pointer-events-auto flex justify-center xl:justify-end">
    <div class="px-3 py-2 text-right bg-black bg-opacity-30">
      <div v-if="largeFleets.length > 0">
        <div
          v-for="fleet in largeFleets"
          :key="fleet.id"
          class="text-sm text-white mb-1 cursor-pointer hover:text-gray-300"
          @click="onClick(fleet)"
        >
          <PlayerName :player-id="fleet.playerId" /> - {{ t('game.military.shipCount', fleet.ships) }}
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
</style>
